import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import PageLoader from "../../../../../components/PageLoader"; import Table from "../../../../../common/components/table-manager/v1.1/table";
import { globalServiceTypes } from "../../../../../redux/global-iship-cloud/global-service-types/action";
import { selectGlobalServiceTypesListItems } from "../../../../../redux/global-iship-cloud/global-service-types/selector";

const GlobalServiceTypes = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const globalServiceTypesListItems = useSelector(selectGlobalServiceTypesListItems)
    const [columnDefs, setColumnDefs] = useState({});
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'Name', headerName: 'Name', searchField: 'Name', filter: true, filterType: 'text' },
            { field: 'Code', headerName: 'Code', searchField: 'Code', filter: true, filterType: 'text' },
        ]);
    }

    const fetchGlobalServiceTypesList = async () => {
        await dispatch(globalServiceTypes.resetAction({ actionType: 'list' }))
        await dispatch(globalServiceTypes.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-service-types/fetch`,
            entity: 'globalServiceTypes',
            jsonData:
            {
                Context: {},
                Records: [{}],
                Pagination: {
                    PageNumber: pageData,
                    PageSize: pageSize,
                    SortField: "Id",
                    SortOrder: "desc",
                }
            }
        }))
    }

    const handleAdd = () => {
        navigate(`${0}`)
    }

    const handleEdit = (data: any) => {
        navigate(`${data?.GlobalHSCodeId}`)
    }

    useEffect(() => {
        createColumnDefs();
        fetchGlobalServiceTypesList();
    }, [pageData, pageSize])

    const additionButtons: any = [

        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
                    <title>Add ServiceTypes</title>
                    <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
                </svg>,
            callback: () => handleAdd(),
        },
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload</title>
                    <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            callback: () => handleReloadData(),
        },
    ];

    const handleReloadData = () => {
        fetchGlobalServiceTypesList();
    }



    const handleDelete = async (data: any) => {
        await dispatch(globalServiceTypes.resetAction({ actionType: 'delete' }))
        await dispatch(globalServiceTypes.delete({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-service-types/delete`,
            entity: 'globalServiceTypes',
            jsonData:
            {
                Context: {},
                Records: [
                    {
                        Id: data?.Id
                    }
                ]
            }
        }))
        await fetchGlobalServiceTypesList();

    }




    const handleSearch = async (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column || data?.searchCriteriaList,
                FieldText: data?.column || data?.searchCriteriaList,
                FieldType: 'text',
                FilterOperatorId: data?.filterOperatorId || 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "Name",
                FieldText: "Name",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }
        await dispatch(globalServiceTypes.resetAction({ actionType: 'list' }))
        await dispatch(globalServiceTypes.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-service-types/fetch`,
            entity: 'globalServiceTypes',
            jsonData: {
                Context: {},
                Records: [{}],
                Pagination: {
                    PageNumber: pageData,
                    PageSize: pageSize,
                    SortField: "Id",
                    SortOrder: "desc",
                    Searches: searchCriteria,
                },
            }
        }))
    }



    return (
        <>

            {globalServiceTypesListItems?.isLoading ? <PageLoader /> :
                <Table
                    columnData={columnDefs}
                    rowData={globalServiceTypesListItems?.result?.items}
                    setPageData={setPageData} setPageSize={setPageSize}
                    paginationData={globalServiceTypesListItems?.result?.pagination}
                    enableFilter={true}
                    onSearch={handleSearch}
                    checkboxConfig={{
                        allowMultiSelect: true,
                        defaultSelectedIds: [],
                        isDisabled: false,
                        keyColumn: 'Id',
                    }}
                    onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons}
                    headingName="Global ServiceTypes"
                />
            }
        </>
    );
};

export default GlobalServiceTypes;


